/**
 * Publication and last-modified dates for insight articles (ISO 8601).
 * Used for Article structured data (datePublished / dateModified).
 */
export const postDates: Record<string, { published: string; modified: string }> = {
  "working-partner-vs-silent-partner": { published: "2026-10-30", modified: "2026-10-30" },
  "founder-bottleneck": { published: "2026-06-18", modified: "2026-09-22" },
  "fractional-coo-cost-australia": { published: "2026-08-04", modified: "2026-11-03" },
  "transport-118-percent": { published: "2026-05-14", modified: "2026-06-30" },
  "mining-90-days": { published: "2026-04-22", modified: "2026-06-11" },
  "electrical-margins": { published: "2026-03-19", modified: "2026-05-27" },
  "healthcare-integrator": { published: "2026-02-24", modified: "2026-05-06" },
  "fractional-vs-fulltime": { published: "2026-01-28", modified: "2026-10-09" },
  "strategy-execution-90-day-rhythm": { published: "2025-12-10", modified: "2026-09-22" },
  "pl-visibility": { published: "2025-11-12", modified: "2026-02-18" },
  "eos-implementer-vs-fractional-coo": { published: "2026-08-12", modified: "2026-11-03" },
  "fractional-coo-vs-consultant-vs-coach": { published: "2026-08-13", modified: "2026-11-03" },
  "when-to-hire-a-coo": { published: "2026-08-14", modified: "2026-08-18" },
  "right-people-right-seats": { published: "2025-10-15", modified: "2026-09-22" },
  "pricing-engine-kmart-tyre-auto": { published: "2026-08-27", modified: "2026-11-03" },
  "pricing-tools-coca-cola-amatil": { published: "2026-08-27", modified: "2026-11-03" },
  "a-plan-nobody-tracks-is-a-document": { published: "2026-09-01", modified: "2026-11-03" },
  "mining-services-first-90-days": { published: "2026-09-01", modified: "2026-11-03" },
  "pricing-tools-5-billion-business": { published: "2026-09-01", modified: "2026-11-03" },
  "the-6m-price-review": { published: "2026-09-01", modified: "2026-11-03" },
  "the-six-minute-operating-scan": { published: "2026-09-01", modified: "2026-11-03" },
  "why-we-publish-our-prices": { published: "2026-09-01", modified: "2026-11-03" },
  "hire-a-general-manager-or-a-fractional-one": { published: "2026-10-15", modified: "2026-10-28" },
  "how-to-step-back-from-sales-in-your-own-business": { published: "2026-10-15", modified: "2026-11-03" },
  "how-to-restructure-a-small-business-group-with-shared-owners": { published: "2026-10-15", modified: "2026-11-03" },
  "13-week-cash-flow-forecast": {
    "published": "2026-10-15",
    "modified": "2026-10-28"
  },
  "revenue-leakage": {
    "published": "2026-10-15",
    "modified": "2026-11-03"
  },
  "commission-and-bonus-structure-design": {
    "published": "2026-10-15",
    "modified": "2026-11-03"
  },
  "payday-super-cash-flow": { published: "2026-10-28", modified: "2026-11-03" },
  "card-surcharge-ban-pricing": { published: "2026-10-28", modified: "2026-10-28" },
  "ai-adoption-small-business": { published: "2026-10-28", modified: "2026-11-03" },
  "small-business-succession-planning": { published: "2026-10-28", modified: "2026-10-28" },
  "security-of-payment-act-subcontractors": { published: "2026-10-28", modified: "2026-10-28" },

};

const requireDates = (slug: string) => {
  const dates = postDates[slug];
  if (!dates) {
    throw new Error(`No publication date recorded for insight slug "${slug}". Add it to src/data/postDates.ts.`);
  }
  return dates;
};

export const publishedAt = (slug: string) => requireDates(slug).published;
export const modifiedAt = (slug: string) => requireDates(slug).modified;

/** Australian calendar dates, fixed to UTC for identical server and browser output. */
export const formatPostDate = (date: string) =>
  new Intl.DateTimeFormat("en-AU", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(`${date}T00:00:00Z`));

export const postDateByline = (slug: string) => {
  const { published, modified } = requireDates(slug);
  const publication = `Published ${formatPostDate(published)}.`;
  return published === modified
    ? publication
    : `${publication} Updated ${formatPostDate(modified)}.`;
};
